export const beforeSendError = (err: unknown): Promise<unknown> =>
  Promise.reject(err)
